<template>
  <div class="preload-container" :style="{ backgroundColor: bgColor }">
    <div class="content">
      <img class="labour-love" src="@/assets/images/labour-love.svg">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Preloader',
  computed: {
    bgColor () {
      return this.$store.state.dayMode ? '#C4F5EA' : '#143254'
    }
  }
}
</script>
<style scoped>
  .preload-container {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 9;
  }

  .preload-container .content {
    position: relative;
    text-align: center;
    display: flex;
    height: 100vh;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/utils/Preloader.vue